import { observer } from 'mobx-react-lite';
import LogicBuilderPanel from './LogicBuilderPanel';
import { LogicBuilderPanelProps, LogicBuilderPanelValueProps } from './types';

export type { LogicBuilderPanelProps, LogicBuilderPanelValueProps };
export default observer(LogicBuilderPanel); // MANUAL OVERRIDE;;
